<template lang="html">
  <div class="qa-header">
    <div class="card">
      <div class="card-top">
        <div class="icon-box" :style="'background-image:url('+survey[$route.params.survey].topbillede2+')'">
          <svg width="522" height="252" viewBox="0 0 522 252" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fill-rule="evenodd">
              <path d="M396.91 192l55.754 55.755c3.906 3.905 10.237 3.905 14.142 0L522 192.561V252H0v-60h396.91z" fill="#F8F8F8"/>
              <path d="M284.806 0L251.93 32.877c-3.905 3.906-3.905 10.237 0 14.143L396.909 192H0V0h284.806z" fill="#BC171D"/>
            </g>
          </svg>
        </div>
        <div class="logo-box" v-html="globalC.logo">

        </div>
        <div class="card-top-content">
          <div class="inside">
            <div class="kicker">{{survey[$route.params.survey].name}}</div>
            <h1 v-if="$route.params.c && !custom">{{ survey[$route.params.survey].cat[$route.params.c].name }}</h1>
            <h1 v-if="!$route.params.c && !custom">Anbefalinger</h1>
            <h1 v-if="custom">{{custom}}</h1>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
  name: 'qaheader',
  props: {
    custom: {
      type: String
    }
  },
  computed: {
    ...mapGetters([
      'survey',
      'globalC'
    ])
  }
}
</script>
<style lang="css">

</style>



// WEBPACK FOOTER //
// src/components/modular/question-header.vue